// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"b3e5dfe0","264":"b3e5dfe0","552":"1a64dec4","990":"b3e5dfe0"}[chunkId] + ".chunk.css";
};